import { Link } from "react-router-dom";
import { useSeo } from "../lib/useSeo";

export const AboutPage = () => {
    useSeo({
        title: "About",
        description:
            "Hydration Hub is a free, science-backed water intake calculator and hydration resource. No accounts, no tracking, no SaaS pitch — just real numbers.",
        path: "/about",
    });

    return (
        <section className="py-12 sm:py-20" data-testid="about-page">
            <div className="max-w-3xl mx-auto px-4 sm:px-6">
                <div className="editorial-label mb-3">About</div>
                <h1 className="text-5xl sm:text-7xl font-black tracking-tighter uppercase leading-none mb-8">
                    About<br />Hydration Hub.
                </h1>
                <div className="space-y-6 text-lg text-foreground/85 leading-relaxed">
                    <p>
                        Hydration Hub is a free, science-backed online resource that helps
                        you figure out exactly how much water you need each day. We built it
                        because most hydration advice online is vague ("eight glasses a
                        day"), commercially motivated, or buried under banner ads.
                    </p>
                    <p>
                        The Site provides personalized daily water intake calculations based
                        on your body weight, activity level, climate, age, and life stage —
                        plus dedicated calculators for workouts, pregnancy, children, and
                        the elderly. All math runs in your browser; nothing is sent to a
                        server.
                    </p>
                    <h2 className="text-3xl font-black tracking-tighter mt-12 mb-4">
                        Our sources
                    </h2>
                    <p>
                        Our calculators draw from accepted clinical and sports-science
                        guidelines, including:
                    </p>
                    <ul className="space-y-2 list-disc pl-6 text-foreground/85">
                        <li>Institute of Medicine (IOM) total water reference intakes</li>
                        <li>European Food Safety Authority (EFSA) adequate intake values</li>
                        <li>American College of Sports Medicine (ACSM) exercise hydration position stand</li>
                        <li>The Holliday-Segar formula for pediatric fluid needs</li>
                    </ul>
                    <h2 className="text-3xl font-black tracking-tighter mt-12 mb-4">
                        How we make money
                    </h2>
                    <p>
                        Hydration Hub is supported by non-intrusive, Google AdSense
                        advertising and clearly-labeled affiliate links. We never put up
                        paywalls, sell data, or run sponsored content disguised as articles.
                        See our{" "}
                        <Link to="/privacy-policy" className="text-primary underline">
                            Privacy Policy
                        </Link>{" "}
                        for the full disclosure.
                    </p>
                    <h2 className="text-3xl font-black tracking-tighter mt-12 mb-4">
                        Disclaimer
                    </h2>
                    <p>
                        The Site is for informational purposes only and is not a substitute
                        for medical advice. We do not know your medical history, kidney
                        function, medications, or specific conditions. If you are pregnant,
                        an elite athlete, or managing a health condition, consult your
                        physician.
                    </p>
                    <h2 className="text-3xl font-black tracking-tighter mt-12 mb-4">
                        Reach the editors
                    </h2>
                    <p>
                        Spotted a typo? Disagree with a number? Email{" "}
                        <a
                            href="mailto:hello@hydration.hub"
                            className="text-primary underline"
                        >
                            hello@hydration.hub
                        </a>
                        .
                    </p>
                </div>
            </div>
        </section>
    );
};
